export const environment = {
    apiUrl: 'https://adminapi.staging.digicoffer.com',
    product: 'form',
    production: false
};